export const SL_GET_BRANCHES_START = "SL_GET_BRANCHES_START",
  SL_GET_BRANCHES_FAILED = "SL_GET_BRANCHES_FAILED",
  SL_GET_BRANCHES_SUCCESS = "SL_GET_BRANCHES_SUCCESS",
  SL_UPDATE_SEARCH_STRING = "SL_UPDATE_SEARCH_STRING",
  SL_UPDATE_SEARCH_URL = "SL_UPDATE_SEARCH_URL",
  SL_UPDATE_BRANCHES = "SL_UPDATE_BRANCHES";
